// File: /src/components/GenReports.js

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';

export const generateReport = (reportType, reportData) => {
	const { data, config } = reportData;

	if (!data || Object.keys(data).length === 0) {
		toast.error('Nenhum item selecionado para o relatório.');
		return;
	}

	// Verifica se é relatório único ou combinado
	const selectedTypes = Object.keys(data).filter(
		(key) => data[key] && data[key].length > 0
	);
	const isCombined = selectedTypes.length > 1;
	const fileName = `relatorio_${
		isCombined ? 'combinado' : selectedTypes[0]
	}.${reportType}`;

	if (reportType === 'pdf') {
		generatePdfReport(data, { ...config, fileName, isCombined });
	} else if (reportType === 'xlsx') {
		generateXlsxReport(data, { ...config, fileName, isCombined });
	}
};

const generatePdfReport = (data, config) => {
	const doc = new jsPDF();
	let yPos = 15;
	// Tamanho da fonte para títulos
	doc.setFontSize(12);

	// Define título geral para relatório único
	if (!config.isCombined) {
		const type = Object.keys(data).find(
			(key) => data[key] && data[key].length > 0
		);
		doc.text(`Relatório de ${config.titles[type]}`, 14, yPos);
		yPos += 10;
	}

	// Gera seções do relatório
	Object.entries(data).forEach(([type, items]) => {
		if (items && items.length > 0) {
			if (config.isCombined) {
				if (yPos > 250) {
					doc.addPage();
					yPos = 15;
				}
				doc.text(config.titles[type], 14, yPos);
				yPos += 10;
			}

			autoTable(doc, {
				head: [config.columns[type]],
				body: items.map((item) => config.formatters[type](item)),
				startY: yPos,
				theme: 'grid',
				styles: { 
					fontSize: 6,
					cellPadding: 2 
				},
				headStyles: {
					fillColor: [41, 128, 185],
					textColor: [255, 255, 255],
				},
			});
			yPos = doc.lastAutoTable.finalY + 10;
		}
	});

	doc.save(config.fileName);
	toast.success(`Relatório em PDF "${config.fileName}" gerado com sucesso!`);
};

const generateXlsxReport = (data, config) => {
	const workbook = XLSX.utils.book_new();
	const selectedTypes = Object.keys(data).filter(
		(key) => data[key] && data[key].length > 0
	);

	// Garante que todos os tipos selecionados sejam processados
	selectedTypes.forEach((type) => {
		if (data[type] && data[type].length > 0) {
			const sheetName = config.isCombined
				? config.titles[type]
				: 'Relatório';
			const rows = data[type].map((item) =>
				config.formatters[type](item)
			);
			const worksheet = XLSX.utils.aoa_to_sheet([
				config.columns[type],
				...rows,
			]);

			// Ajusta largura das colunas
			const columnWidths = config.columns[type].map(() => ({ wch: 15 }));
			worksheet['!cols'] = columnWidths;

			XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
		}
	});

	if (selectedTypes.length === 0) {
		toast.error('Nenhum dado selecionado para o relatório.');
		return;
	}

	const excelBuffer = XLSX.write(workbook, {
		bookType: 'xlsx',
		type: 'array',
	});
	saveAs(
		new Blob([excelBuffer], { type: 'application/octet-stream' }),
		config.fileName
	);
	toast.success(
		`Relatório em Excel "${config.fileName}" gerado com sucesso!`
	);
};
